export const PUPPETS_DATA = [
  {
    id: 1,
    name: "Zen",
    description: "A purple zebra who loves painting haystacks from claude monet, he also likes changing colors of zebras, green, yellow, orange, blue, etc.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2021",
    appearances: ["Baby Monet (2005)"],
    images: {
      front: "/puppets/zen/front.jpg",
      gallery: ["/puppets/zen/left.jpg", "/puppets/zen/right.jpg", "/puppets/zen/smile.jpg"]
    },
    videos: []
  },
  {
    id: 2,
    name: "Neptune",
    description: "A friendly sea turtle, known for hosting underwater adventures. It has a soft shell and a friendly expression that charms children.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2021",
    appearances: ["Baby Neptune (2003, 2009)"],
    images: {
      front: "/puppets/neptune/front.jpg",
      gallery: ["/puppets/neptune/left.jpg", "/puppets/neptune/right.jpg", "/puppets/neptune/smile.jpg"]
    },
    videos: []
  },
  {
    id: 3,
    name: "Mozart",
    description: "A Koala who likes to conduct orchestras and help Hugo Hippo during the orchestra preparation. He also likes to stay in Noah's Ark.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2021",
    appearances: ["Baby Mozart (2008)", "Baby Noah (2004, 2009)", "Meet the Orchestra (2006)", "Baby's First Sounds (2008)", "World Animal Adventure (2009)"],
    images: {
      front: "/puppets/mozart/front.jpg",
      gallery: ["/puppets/mozart/left.jpg", "/puppets/mozart/right.jpg", "/puppets/mozart/smile.jpg"]
    },
    videos: [
      { title: "Mozart Intro - Mario's World", url: "https://www.youtube.com/watch?v=vDI64v6Zgmw" },
      { title: "Baby Mozart 2 Trailer", url: "https://www.youtube.com/watch?v=pnKujlsWa2A" },
      { title: "The Bathroom (From the Cancelled 2015 Baby Mozart 3)", url: "https://www.youtube.com/watch?v=JqZt2Ii-dWs" },
      { title: "Quacker The Duck vs Mozart the Koala", url: "https://www.youtube.com/watch?v=H9LOj5sD8mw" }
    ]
  },
  {
    id: 4,
    name: "Misty",
    description: "A blue mouse who likes cheese, he also likes playing with chilla the blue mouse in the 2009 version of baby macdonald",
    manufacturer: "DMP Creative",
    acquisitionDate: "2022",
    appearances: [
      "Baby MacDonald (2003-2009)",
      "Baby Galileo (2003-2004)",
      "Baby Santa's Music Box (2000-2004)",
      "Baby Van Gogh (2000-2004)",
      "Baby Wordsworth (2005-2009)",
      "Animals Around Me (2010-2012)",
      "World Of Colors (2009)"
    ],
    images: {
      front: "/puppets/misty/front.jpg",
      gallery: ["/puppets/misty/left.jpg", "/puppets/misty/right.jpg", "/puppets/misty/smile.jpg"]
    },
    videos: []
  },
  {
    id: 5,
    name: "Elliot",
    description: "A yellow cat who enjoys spending time with friends like wordsworth the parrot, pavlov the dog, bluebird, misty the mouse and violet the mouse.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2022",
    appearances: ["Baby Wordsworth (2005-2009)"],
    images: {
      front: "/puppets/elliot/front.jpg",
      gallery: ["/puppets/elliot/left.jpg", "/puppets/elliot/right.jpg", "/puppets/elliot/smile.jpg"]
    },
    videos: []
  },
  {
    id: 6,
    name: "Pavlov",
    description: "A dog who first appeared in Baby Newton since 2002, he also appeared in baby beethoven and numbers nursery.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2022",
    appearances: [
      "Baby Newton (2002-2004)",
      "Baby Beethoven (2002-2012)",
      "Numbers Nursery (2003-2004)",
      "On The Go (2005)",
      "Baby's First Moves (2006-2009)",
      "My First Signs (2007-2009)",
      "Baby Mozart (2008)",
    ],
    images: {
      front: "/puppets/pavlov/front.jpg",
      gallery: ["/puppets/pavlov/left.jpg", "/puppets/pavlov/right.jpg", "/puppets/pavlov/smile.jpg"]
    },
    videos: []
  },
  {
    id: 7,
    name: "Quacker",
    description: "A yellow duck who first appeared in baby newton since 2002, he also appeared in baby beethoven, baby neptune, numbers nursery, my first signs and the 2008 version of baby mozart",
    manufacturer: "DMP Creative",
    acquisitionDate: "2022",
    appearances: [
      "Baby Newton (2002-2004)",
      "Baby Beethoven (2002-2012)",
      "Baby Neptune (2003-2009)",
      "Numbers Nursery (2003-2004)",
      "My First Signs (2007-2009)",
      "Baby Mozart (2008)",
    ],
    images: {
      front: "/puppets/quacker/front.jpg",
      gallery: ["/puppets/quacker/left.jpg", "/puppets/quacker/right.jpg", "/puppets/quacker/smile.jpg"]
    },
    videos: []
  },
  {
    id: 8,
    name: "Beethoven",
    description: "A giraffe who first appeared in baby beethoven since late-2002, he also appeared in baby galileo, numbers nursery, meet the orchestra, baby’s first moves, discovering shapes and baby’s first sounds.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2023",
    appearances: [
      "Baby Beethoven (2002-2012)",
      "Baby Galileo (2003-2004)",
      "Numbers Nursery (2003-2004)",
      "Meet The Orchestra (2006)",
      "Baby's First Moves (2006-2009)",
      "Discovering Shapes (2007)",
      "Baby's First Sounds (2008)",
    ],
    images: {
      front: "/puppets/beethoven/front.jpg",
      gallery: ["/puppets/beethoven/left.jpg", "/puppets/beethoven/right.jpg", "/puppets/beethoven/smile.jpg"]
    },
    videos: []
  },
  {
    id: 9,
    name: "Neighton",
    description: "A brown horse who first appeared in baby newton, he also appeared in baby beethoven, etc.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2023",
    appearances: [
      "Baby Newton (2002-2004)",
      "Baby Beethoven (2002-2012)",
      "Numbers Nursery (2003-2004)",
      "Baby MacDonald (2003-2009)",
      "On The Go (2005)",
      "Baby's First Sounds (2008)",
      "World Animal Adventure (2009)",
    ],
    images: {
      front: "/puppets/neighton/front.jpg",
      gallery: ["/puppets/neighton/left.jpg", "/puppets/neighton/right.jpg", "/puppets/neighton/smile.jpg"]
    },
    videos: []
  },
  {
    id: 10,
    name: "Wellington",
    description: "A black and white cow who appeared in baby newton since early-2002",
    manufacturer: "DMP Creative",
    acquisitionDate: "2024",
    appearances: ["Baby Newton (2002-2004)", "Baby Beethoven (2002-2012)", "Baby Galileo (2003-2004)", "Numbers Nursery (2003-2004)", "Baby Mozart (2008)",],
    images: {
      front: "/puppets/wellington/front.jpg",
      gallery: ["/puppets/wellington/left.jpg", "/puppets/wellington/right.jpg", "/puppets/wellington/smile.jpg"]
    },
    videos: []
  },
  {
    id: 11,
    name: "Roger",
    description: "A red rooster who appeared in Baby MacDonald since 2003.",
    manufacturer: "DMP Creative",
    acquisitionDate: "2025",
    appearances: [
      "Baby MacDonald (2003-2009)",
      "Baby Beethoven (2008)",
      "World Of Colors (2009)",
      "Animals Around Me (2010-2012)",
    ],
    images: {
      front: "/puppets/roger/front.jpg",
      gallery: ["/puppets/roger/left.jpg", "/puppets/roger/right.jpg", "/puppets/roger/smile.jpg"]
    },
    videos: []
  },
  {
    id: 12,
    name: "Vivaldi",
    description: "A green mallard who became friends with monet the zebra in baby monet since ",
    manufacturer: "DMP Creative",
    acquisitionDate: "2025",
    appearances: [
      "Baby Monet (2005)",
      "Meet The Orchestra (2006)",
    ],
    images: {
      front: "/puppets/vivaldi/front.jpg",
      gallery: ["/puppets/vivaldi/left.jpg", "/puppets/vivaldi/right.jpg", "/puppets/vivaldi/smile.jpg"]
    },
    videos: []
  },
  {
    id: 13,
    name: "Julie",
    description: "A sheep who first appeared in baby macdonald since 2003",
    manufacturer: "DMP Creative",
    acquisitionDate: "2025",
    appearances: [
      "Baby MacDonald (2003-2009)",
      "On The Go (2005)",
      "Lullaby Time (2007)",
      "Baby's First Sounds (2008)",
      "World Of Colors (2009)",
      "Baby Lullaby (2011-2012)",
    ],
    images: {
      front: "/puppets/julie/front.jpg",
      gallery: ["/puppets/julie/left.jpg", "/puppets/julie/right.jpg", "/puppets/julie/smile.jpg"]
    },
    videos: []
  },
  {
    id: 14,
    name: "Zippy",
    description: "A black and white zebra who sneezes his black stripes off in World Animal Adventures, 2009",
    manufacturer: "DMP Creative",
    acquisitionDate: "2026",
    appearances: [
      "Baby Monet (2005-2007)",
      "World Animal Adventure (2009)"
    ],
    images: {
      front: "/puppets/zippy/front.jpg",
      gallery: ["/puppets/zippy/left.jpg", "/puppets/zippy/right.jpg", "/puppets/zippy/smile.jpg"]
    },
    videos: []
  }
];